(function() {

  angular
  .module('meanApp')
  .factory('Ingredient', Ingredient);

  Ingredient.$inject = [
        '$http', 
        'httpAuth', 
        '$rootScope', 
        'Model', 
        'currentUser',
        '$q'];
  function Ingredient (
        $http, 
        httpAuth, 
        $rootScope, 
        Model, 
        currentUser,
        $q) {
    var Ingredient = function (userData) {
        Model.apply(this, arguments);
    },
    TAGS_BY_COLOR = ['complicated', 'nohob', 'protein', 'cold', 'eco', 'lowcarb', 'nopig', 'vegan', 'paleo', 'vegetarian','local', 'nogluten' , 'nooven', 'maincourse', 'nomicrowave',  'entry', 'pleasure', 'savory', 'aperitif', 'lowcalory',  'season', 'dessert', 'fast', 'sweet', 'hot'];

    Ingredient.APIPath = 'ingredients';
    Ingredient.idAttribute = 'slug';
    Ingredient.prototype = {
        _load: function(id, deferred) {
            var scope = this;
            
            $http.get('/api/' + Ingredient.APIPath + '/' + id)
              .success(function(data) {
                  var instance = scope._retrieveInstance(data._id, data);
                  deferred.resolve(instance);
              })
              .error(function() {
                  console.log('user collection get GOT rejected');
                  deferred.reject();
              });
        },

        updateWithPicture : function(formData) {
            var deferred = $q.defer(),
            scope = this;
            
            httpAuth.put('/api/'+this.getAPIPath()+'/'+this._id, formData, {
                headers: {'Content-Type': undefined }
            })
            .success(function(data) {
                //TODO merge the result and everything ?
                //just merge slug _id and the recipeFilePath
                this.setData(data);
                deferred.resolve(this);
            }.bind(this))
            .error(function(err) {
                console.log('JS front end success for saving recipe');
                deferred.reject(err);
            });
            return deferred.promise;
        },


        like: function() {
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.post('/api/users/'+$rootScope.currentUser._id +'/'+ Ingredient.APIPath + '/' + this._id+'/likes', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function(data) {
                console.log('the api like on ingredient succeeded');
            })
            .error(function() {
                console.log('the api like on ingredient failed');
            });
        },

        unlike: function() {
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.delete('/api/users/'+$rootScope.currentUser._id +'/'+ Ingredient.APIPath + '/' + this._id+'/likes', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function(data) {
                console.log('the api like on ingredient succeeded');
            })
            .error(function() {
                console.log('the api like on ingredient failed');
            });
        },

        dislike: function() {
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.post('/api/users/'+$rootScope.currentUser._id +'/'+ Ingredient.APIPath + '/' + this._id+'/dislikes', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function(data) {
                console.log('the api like on ingredient succeeded');
            })
            .error(function() {
                console.log('the api like on ingredient failed');
            });
        },

        undislike: function() {
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.delete('/api/users/'+$rootScope.currentUser._id +'/'+ Ingredient.APIPath + '/' + this._id+'/dislikes', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function(data) {
                console.log('the api like on ingredient succeeded');
            })
            .error(function() {
                console.log('the api like on ingredient failed');
            });
        },

        getInteractions: function() {
            //step 1 get the id of current user
            //step 2 perform the call
            /*return httpAuth.get('/api/users/'+$rootScope.currentUser._id +'/'+ Ingredient.APIPath + '/' + this._id+'/interactions', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            });*/

            var deferred = $q.defer(),
            url = '',
            that = this;
            //step 1 get the id of current user
            //step 2 perform the call
            currentUser.get().then(function(userModel) {
                //2 different APIs requested according to user connection or not
                url = userModel._id ? ('/api/users/'+userModel._id +'/'+ Ingredient.APIPath + '/' + that._id+'/interactions') : ('/api/'+ Ingredient.APIPath + '/' + that._id+'/interactions'); 
                httpAuth.get(url, {}, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .success(function(result) {
                    deferred.resolve(result);
                })
                .error(function(err) {
                    deferred.reject(err);
                });
            });

            return deferred.promise;
        },

        getAPIPath: function() {
            return Ingredient.APIPath;
        },
        getIdAttribute : function() {
            return Ingredient.idAttribute;
        },
        getThumb : function (size) {
            return 'api/thumb/ingredients/'+this._id+'/size/'+size+'/update/'+this.ingredientUpdate;
        },
        _getEnergyDensityPoints : function (numberInKj) {
            var ans = 10;
            switch(true) {
                case(numberInKj<= 335) : ans = 0; break;
                case(numberInKj <= 670) : ans = 1; break;
                case(numberInKj <= 1005) : ans = 2; break;
                case(numberInKj <= 1340) : ans = 3; break;
                case(numberInKj <= 1675) : ans = 4; break;
                case(numberInKj <= 2010) : ans = 5; break;
                case(numberInKj <= 2345) : ans = 6; break;
                case(numberInKj <= 2680) : ans = 7; break;
                case(numberInKj <= 3015) : ans = 8; break;
                case(numberInKj <= 3350) : ans = 9; break;
                case(numberInKj >  3350) : ans = 10; break;
            }

            return ans;
        },

        
        _getEnergyDensityPointsForDrink : function (numberInKj) {
            var ans = 10;
            switch(true) {
                case(numberInKj<= 0) : ans = 0; break;
                case(numberInKj <= 30) : ans = 1; break;
                case(numberInKj <= 60) : ans = 2; break;
                case(numberInKj <= 90) : ans = 3; break;
                case(numberInKj <= 120) : ans = 4; break;
                case(numberInKj <= 150) : ans = 5; break;
                case(numberInKj <= 180) : ans = 6; break;
                case(numberInKj <= 210) : ans = 7; break;
                case(numberInKj <= 240) : ans = 8; break;
                case(numberInKj <= 270) : ans = 9; break;
                case(numberInKj >  270) : ans = 10; break;
            }

            return ans;
        },

        _getSaturatedFatPoints : function (numberInKj) {
            var ans = 10;
            switch(true) {
                case(numberInKj<= 1) : ans = 0; break;
                case(numberInKj <= 2) : ans = 1; break;
                case(numberInKj <= 3) : ans = 2; break;
                case(numberInKj <= 4) : ans = 3; break;
                case(numberInKj <= 5) : ans = 4; break;
                case(numberInKj <= 6) : ans = 5; break;
                case(numberInKj <= 7) : ans = 6; break;
                case(numberInKj <= 8) : ans = 7; break;
                case(numberInKj <= 9) : ans = 8; break;
                case(numberInKj <= 10) : ans = 9; break;
                case(numberInKj >  10) : ans = 10; break;
            }

            return ans;
        },

        _getSaturatedFatPointsForAddedFat : function (numberInKj) {
            var ans = 10;
            switch(true) {
                case(numberInKj< 10) : ans = 0; break;
                case(numberInKj < 16) : ans = 1; break;
                case(numberInKj < 22) : ans = 2; break;
                case(numberInKj < 28) : ans = 3; break;
                case(numberInKj < 34) : ans = 4; break;
                case(numberInKj < 40) : ans = 5; break;
                case(numberInKj < 46) : ans = 6; break;
                case(numberInKj < 52) : ans = 7; break;
                case(numberInKj < 58) : ans = 8; break;
                case(numberInKj < 64) : ans = 9; break;
                case(numberInKj >= 64) : ans = 10; break;
            }

            return ans;
        },

         _getSugarPoints : function (numberInKj) {
            var ans = 10;
            switch(true) {
                case(numberInKj<= 4.5) : ans = 0; break;
                case(numberInKj <= 9) : ans = 1; break;
                case(numberInKj <= 13.5) : ans = 2; break;
                case(numberInKj <= 18) : ans = 3; break;
                case(numberInKj <= 22.5) : ans = 4; break;
                case(numberInKj <= 27) : ans = 5; break;
                case(numberInKj <= 31) : ans = 6; break;
                case(numberInKj <= 36) : ans = 7; break;
                case(numberInKj <= 40) : ans = 8; break;
                case(numberInKj <= 45) : ans = 9; break;
                case(numberInKj >  45) : ans = 10; break;
            }

            return ans;
        },

        _getSugarPointsForDrink : function (numberInKj) {
            var ans = 10;
            switch(true) {
                case(numberInKj<= 0) : ans = 0; break;
                case(numberInKj <= 1.5) : ans = 1; break;
                case(numberInKj <= 3) : ans = 2; break;
                case(numberInKj <= 4.5) : ans = 3; break;
                case(numberInKj <= 6) : ans = 4; break;
                case(numberInKj <= 7.5) : ans = 5; break;
                case(numberInKj <= 9) : ans = 6; break;
                case(numberInKj <= 10.5) : ans = 7; break;
                case(numberInKj <= 12) : ans = 8; break;
                case(numberInKj <= 13.5) : ans = 9; break;
                case(numberInKj >  13.5) : ans = 10; break;
            }

            return ans;
        },

        _getSodiumPoints : function (numberInKj) {
            var ans = 10;
            switch(true) {
                case(numberInKj<= 90) : ans = 0; break;
                case(numberInKj <= 180) : ans = 1; break;
                case(numberInKj <= 270) : ans = 2; break;
                case(numberInKj <= 360) : ans = 3; break;
                case(numberInKj <= 450) : ans = 4; break;
                case(numberInKj <= 540) : ans = 5; break;
                case(numberInKj <= 630) : ans = 6; break;
                case(numberInKj <= 720) : ans = 7; break;
                case(numberInKj <= 810) : ans = 8; break;
                case(numberInKj <= 900) : ans = 9; break;
                case(numberInKj >  900) : ans = 10; break;
            }

            return ans;
        },

        _getFruitsAndVegetablesPoints : function(quantity) {
            var ans = 0;
            switch(true) {
                case(quantity <= 40): ans = 0; break;
                case(quantity <= 60): ans = 1; break;
                case(quantity <= 80): ans = 2; break;
                case(quantity > 80): ans = 5; break;
            }
            return ans;
        },

        _getFruitsAndVegetablesPointsForDrink : function(quantity) {
            var ans = 0;
            switch(true) {
                case(quantity <= 40): ans = 0; break;
                case(quantity > 40): ans = 2; break;
                case(quantity > 60): ans = 4; break;
                case(quantity > 80): ans = 10; break;
            }
            return ans;
        },

        _getFiberPoints : function(quantity) {
            var ans = 0;
            switch(true) {
                case(quantity <= 0.9): ans = 0; break;
                case(quantity <= 1.9): ans = 1; break;
                case(quantity <= 2.8): ans = 2; break;
                case(quantity <= 3.7): ans = 3; break;
                case(quantity <= 4.7): ans = 4; break;
                case(quantity > 4.7): ans = 5; break;
            }
            return ans;
        },

        _getProteinsPoints : function(quantity) {
            var ans = 0;
            switch(true) {
                case(quantity <= 1.6): ans = 0; break;
                case(quantity <= 3.2): ans = 1; break;
                case(quantity <= 4.8): ans = 2; break;
                case(quantity <= 6.4): ans = 3; break;
                case(quantity <= 8.0): ans = 4; break;
                case(quantity > 8.0): ans = 5; break;
            }
            return ans;
        },

        _isCheese : function() {
            var ans= false, 
            features = this['features'];
            features.forEach(function(feature) {
                if (feature.easyID === 4) {
                    ans = true;
                }
            });

            return ans;
        },

        _isAddedFat: function() {
            var ans= false, 
            features = this['features'];
            features.forEach(function(feature) {
                if (feature.easyID === 5) {
                    ans = true;
                }
            });

            return ans;
        },

        _isDrink: function() {
            var ans= false, 
            features = this['features'];
            features.forEach(function(feature) {
                if (feature.easyID === 7) {
                    ans = true;
                }
            });

            return ans;
        },  

        getNutriscoreLetter : function() {
            //create some JS cache
            if(!this.nutriscoreLetter) {
                var nutriscore = this._getNutriscore(),
                departmentId = this.department.easyID,
                nutriscoreLetter;
                if (this._isDrink() === true) {
                    switch(true) {
                        //TODO consider having something for mineral waters
                        case(nutriscore <= 0): nutriscoreLetter = 'A'; break;
                        case(nutriscore <= 1): nutriscoreLetter = 'B'; break;
                        case(nutriscore <= 5): nutriscoreLetter = 'C'; break;
                        case(nutriscore <= 9): nutriscoreLetter = 'D'; break;
                        case(nutriscore >= 10): nutriscoreLetter = 'E'; break;
                    }
                }
                else {
                    switch(true) {
                        //TODO consider having something for mineral waters otherwise some drinks might be A even if it is reserved for mineral waters
                        case(nutriscore <= -1): nutriscoreLetter = 'A'; break;
                        case(nutriscore <= 2): nutriscoreLetter = 'B'; break;
                        case(nutriscore <= 10): nutriscoreLetter = 'C'; break;
                        case(nutriscore <= 18): nutriscoreLetter = 'D'; break;
                        case(nutriscore > 18): nutriscoreLetter = 'E'; break;
                    }
                }
                //specific letter for alcohol that is not beer
                if(departmentId < 71 && departmentId > 61 && departmentId != 65) {
                    nutriscoreLetter = 'F';
                }
                //force the letter to be F if this is an alcohol
                this.nutriscoreLetter = nutriscoreLetter;
            }

            return this.nutriscoreLetter;
        },

        _getNutriscore : function() {
            var nutrientsQuantity = this['nutrientsQuantity'],
            percentageFruitsAndVegetables = this['percentageFruitsAndVegetables'] || 0,
            negativeComposante= 0,
            positiveComposante= 0,
            saturatedFat,
            sugarsQuantity = 0,
            fibersQuantity,
            totalLipidQuantity,
            totalSaturatedFatQuantity = 0,
            carbohydratesQuantity,
            sodiumQuantity,
            proteinsQuantity,
            kilocalories,
            kilojoules,
            nutriscore,
            isCheese = this._isCheese(),
            isAddedFat = this._isAddedFat(),
            isDrink = this._isDrink(),
            fatPointsForAddedFat;

            nutrientsQuantity.forEach(function(nutrientQuantity) {
                switch(nutrientQuantity.nutrient._id) {
                    case 291: fibersQuantity = nutrientQuantity.quantity; break;//fibers in g
                    case 205: carbohydratesQuantity = nutrientQuantity.quantity; break;//carbohydrates in g (not used for nutriscore)
                    case 204: totalLipidQuantity = nutrientQuantity.quantity; break; //total lipids, (not used for nutriscore)
                    case 606: totalSaturatedFatQuantity = nutrientQuantity.quantity; break;
                    case 203: proteinsQuantity= nutrientQuantity.quantity; break;
                    case 307: sodiumQuantity= nutrientQuantity.quantity; break;
                    case 269: sugarsQuantity= nutrientQuantity.quantity; break;
                    case 208: kilocalories = nutrientQuantity.quantity; break;
                    case 268: kilojoules = nutrientQuantity.quantity; break;
                }
            });

            if(isDrink) {
                return this._getEnergyDensityPointsForDrink(kilojoules || kilocalories*4.184) 
                + this._getSugarPointsForDrink(sugarsQuantity)
                - this._getFruitsAndVegetablesPointsForDrink(percentageFruitsAndVegetables);
            }

            fatPointsForAddedFat = isAddedFat ? this._getSaturatedFatPointsForAddedFat(100*totalSaturatedFatQuantity/totalLipidQuantity) :  this._getSaturatedFatPoints(totalSaturatedFatQuantity);
            negativeComposante = this._getEnergyDensityPoints(kilojoules || kilocalories*4.184) 
            + fatPointsForAddedFat
            + this._getSugarPoints(sugarsQuantity)
            + this._getSodiumPoints(sodiumQuantity);

            var pointsFruitsAndVegetables = this._getFruitsAndVegetablesPoints(percentageFruitsAndVegetables);
            //specific scoring rules
            if (pointsFruitsAndVegetables < 5 && negativeComposante > 10 && !isCheese) { //except if this is cheese (weird)
                positiveComposante = pointsFruitsAndVegetables
                + this._getFiberPoints(fibersQuantity);
            }
            else {
                positiveComposante = pointsFruitsAndVegetables
                + this._getFiberPoints(fibersQuantity)
                + this._getProteinsPoints(proteinsQuantity);
            }

            nutriscore = negativeComposante - positiveComposante;

            return nutriscore;
        },

        //we consider that a nutriscore with letter D or E means it has a lot of fat and or lot of salt so the body tends to love it
        _hasPleasureTag : function() {
            var nutriscoreLetter = this.getNutriscoreLetter();
            return nutriscoreLetter === 'E' || nutriscoreLetter === 'D';
        },

        _hasNoGlutenTag : function() {
            var ans = true;
            this['allergensRisk'].forEach(function(allergenRisk) {
                if(allergenRisk.allergen.easyID === 0 && allergenRisk.risk==="HIGH") {
                    ans = false;
                }
            });

            return ans;
        },

        _hasEcoTag: function() {
            return (this.price && this.price < 5);
        },

        _hasSeasonTag : function() {
            var date = new Date();
            return (this.monthsSoldInFrance && this.monthsSoldInFrance.indexOf(date.getMonth()) > -1);
        },

        _getFeaturesIntoTags: function() {
            var ans = [],
            hasPork = false;

            this.features.forEach(function(feature) {
                switch(feature.easyID) {
                    case 0: ans.push('vegan'); break;
                    case 1: ans.push('vegetarian'); break;
                    case 2: ans.push('paleo'); break;
                    case 6: hasPork = true; break;
                    case 8: ans.push('local'); break;
                    //case 8: ans.push('local'); break; //TODO add a new tag ? local ? and also from season ?
                }
            });

            //if no pork push the no pork tag
            if(!hasPork) {
                ans.push('nopig');
            }

            return ans;
        },

        //must be more than 8g //TODO mutualize constant with ingredient controller
        _getNutrientsIntoTags : function() {
            var ans = [],
            nutrientsQuantity = this['nutrientsQuantity'],
            sugarsQuantity = 0,
            sodiumQuantity = 0,
            proteinsQuantity = 0,
            kilocalories = 0,
            kilojoules = 0;

            nutrientsQuantity.forEach(function(nutrientQuantity) {
                switch(nutrientQuantity.nutrient._id) {
                    case 307: sodiumQuantity= nutrientQuantity.quantity; break;
                    case 269: sugarsQuantity= nutrientQuantity.quantity; break;
                    case 203: proteinsQuantity= nutrientQuantity.quantity; break; 
                    case 208: kilocalories = nutrientQuantity.quantity; break;
                    case 268: kilojoules = nutrientQuantity.quantity; break;
                }
            });

            if(sugarsQuantity > 5.5) {
                ans.push('sweet');
            }
            else if (sugarsQuantity > 4 && sodiumQuantity < 10 ){
                ans.push('sweet');
            }

            if(sodiumQuantity > 50) {
                ans.push('savory');
            }
            else if (sodiumQuantity > 10 && sugarsQuantity < 5.5 ){
                ans.push('savory');
            }

            if(proteinsQuantity > 8) {
                ans.push('protein');
            }
            kilocalories =  kilocalories ? kilocalories : kilojoules*4.184;
            if(kilocalories < 160) {
                ans.push('lowcalory');
            }

            return ans;
        },

        getTagNames : function() {
            var tagNames = [];

            if(this._hasPleasureTag()) {
                tagNames.push('pleasure');
            }

            if(this._hasNoGlutenTag()) {
                tagNames.push('nogluten');
            }

            if(this._hasEcoTag()) {
                tagNames.push('eco');
            }

            if(this._hasSeasonTag()) {
                tagNames.push('season');
            }

            return tagNames.concat(this._getFeaturesIntoTags()).concat(this._getNutrientsIntoTags()).sort(function(tag1, tag2) {
                return TAGS_BY_COLOR.indexOf(tag2) - TAGS_BY_COLOR.indexOf(tag1);
            });
        }
    };
    
    angular.extend(Ingredient.prototype, Model.prototype);

    return Ingredient;
  };

})();